import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import { Localize } from 'components/service';
import { useMutation } from '@apollo/client';
import { PRINT_LABEL_GRAPHIC_STAND } from 'graphql/mutation/graphic-stand-gql';
import Icons from 'components/icons';
import { errorNotification } from "components/request-result";
// import { saveAsFile } from 'utils';


const GraphicStandMaterialsField = ({ graphicStand }) => {

    const [ isLoading, setIsLoading ] = useState(false);

    const [ printLabelGraphicStand ] = useMutation(PRINT_LABEL_GRAPHIC_STAND, {
        onCompleted: (data) => {
            if (data?.graphicStandPrintLabel?.file)
            {
                // saveAsFile.document(data.standPrintCollectGraphics.file, `collect-graphics-${ stand?.id }.pdf`);
                window.open(data.graphicStandPrintLabel.file, '_blank');
            }
            setIsLoading(false);
        },
        onError: (error) => {
            errorNotification(error);
            setIsLoading(false);
        }
    });



    return (
        <ul className='download-file-list'>

            <li key="print-label">
                <div className='download-file'>
                    <Link
                        to='#'
                        style={ { whiteSpace: 'nowrap', minWidth: '106px' } }
                        onClick={ () => {
                            setIsLoading(true);
                            printLabelGraphicStand({
                                variables: {
                                    graphic_stand_id: graphicStand?.id
                                }
                            });
                        } }
                    >
                        <Icons.Printer /> <span className='link-text'><Localize>ACTIONS.List_Item_Label_PrintLabel</Localize></span>
                        { isLoading && <Loading3QuartersOutlined spin style={ { marginLeft: '5px' } } /> }
                    </Link>
                </div>
            </li>
        </ul>
    );
};

export default GraphicStandMaterialsField;